import { render } from "./LabelsSelect.vue?vue&type=template&id=2ba486b4"
import script from "./LabelsSelect.vue?vue&type=script&lang=js"
export * from "./LabelsSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__